var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBluesky = function SvgBluesky(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    fill: "none",
    viewBox: "0 0 28 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.07 1.616C9.28 3.962 12.731 8.718 14 11.27c1.268-2.552 4.72-7.31 7.93-9.655C24.248-.077 28-1.387 28 2.78c0 .832-.49 6.992-.778 7.992-1 3.477-4.641 4.364-7.88 3.827 5.662.939 7.103 4.046 3.992 7.154-5.909 5.902-8.493-1.48-9.155-3.373-.121-.346-.178-.509-.179-.37 0-.139-.058.024-.179.37-.662 1.892-3.246 9.276-9.154 3.373-3.112-3.108-1.671-6.216 3.992-7.154-3.24.537-6.882-.35-7.881-3.827C.49 9.773 0 3.613 0 2.781 0-1.387 3.753-.077 6.07 1.615"
  })));
};
export default SvgBluesky;